module.exports = __webpack_public_path__ + "img/newEnergy.6311865b.png";